<template>
	<table v-if="!hideUtm" class="order__details">
		<tbody>
		<tr class="top-border">
			<td class="top-border__container" colspan="2">
				<div class="top-border__line"></div>
			</td>
		</tr>
		<tr v-if="isNotEmpty(source)">
			<td><b>{{ $t("utm.orderSource") }}</b></td>
			<td>{{ source }}</td>
		</tr>
		<tr v-if="utm && isNotEmpty(utm.source)">
			<td><b>{{ $t("utm.source") }}</b></td>
			<td>{{ utm.source }}</td>
		</tr>
		<tr v-if="utm && isNotEmpty(utm.search_word)">
			<td><b>{{ $t("utm.search_word") }}</b></td>
			<td>{{ utm.search_word }}</td>
		</tr>
		<tr v-if="utm && isNotEmpty(utm.cid)">
			<td><b>{{ $t("utm.cid") }}</b></td>
			<td>{{ utm.cid }}</td>
		</tr>
		<tr v-if="utm && isNotEmpty(utm.geo)">
			<td><b>{{ $t("utm.geo") }}</b></td>
			<td>{{ utm.geo }}</td>
		</tr>
		<tr v-if="utm && isNotEmpty(utm.medium)">
			<td><b>{{ $t("utm.medium") }}</b></td>
			<td>{{ utm.medium }}</td>
		</tr>
		<tr v-if="utm && isNotEmpty(utm.browser_agent)">
			<td><b>{{ $t("utm.browser_agent") }}</b></td>
			<td>{{ utm.browser_agent }}</td>
		</tr>
		<tr v-if="utm && isNotEmpty(utm.sid)">
			<td><b>{{ $t("utm.sid") }}</b></td>
			<td>{{ utm.sid }}</td>
		</tr>
		<tr v-if="utm && isNotEmpty(utm.sct)">
			<td><b>{{ $t("utm.sct") }}</b></td>
			<td>{{ utm.sct }}</td>
		</tr>

		<tr v-if="utm && isNotEmpty(utm.gclid)">
			<td><b>{{ $t("utm.gclid") }}</b></td>
			<td>{{ utm.gclid }}</td>
		</tr>

		<tr v-if="utm && isNotEmpty(utm.matchtype)">
			<td><b>{{ $t("utm.matchtype") }}</b></td>
			<td>{{ utm.matchtype }}</td>
		</tr>

		<tr v-if="utm && isNotEmpty(utm.wbraid)">
			<td><b>{{ $t("utm.wbraid") }}</b></td>
			<td>{{ utm.wbraid }}</td>
		</tr>

		<tr v-if="utm && isNotEmpty(utm.gbraid)">
			<td><b>{{ $t("utm.gbraid") }}</b></td>
			<td>{{ utm.gbraid }}</td>
		</tr>

		<tr v-if="utm && isNotEmpty(utm.fbclid)">
			<td><b>{{ $t("utm.fbclid") }}</b></td>
			<td>{{ utm.fbclid }}</td>
		</tr>
		<tr v-if="utm && utm.campaign && isNotEmpty(utm.campaign.utm_source)">
			<td><b>{{ $t("utm.utm_source") }}</b></td>
			<td>{{ utm.campaign.utm_source }}</td>
		</tr>
		<tr v-if="utm && utm.campaign && isNotEmpty(utm.campaign.utm_medium)">
			<td><b>{{ $t("utm.utm_medium") }}</b></td>
			<td>{{ utm.campaign.utm_medium }}</td>
		</tr>
		<tr v-if="utm && utm.campaign && isNotEmpty(utm.campaign.utm_term)">
			<td><b>{{ $t("utm.utm_term") }}</b></td>
			<td>{{ utm.campaign.utm_term }}</td>
		</tr>
		<tr v-if="utm && utm.campaign && isNotEmpty(utm.campaign.utm_campaign)">
			<td><b>{{ $t("utm.utm_campaign") }}</b></td>
			<td>{{ utm.campaign.utm_campaign }}</td>
		</tr>
		<tr v-if="utm && utm.campaign && isNotEmpty(utm.campaign.adgroupid)">
			<td><b>{{ $t("utm.adgroupid") }}</b></td>
			<td>{{ utm.campaign.adgroupid }}</td>
		</tr>
		<tr v-if="utm && utm.campaign && isNotEmpty(utm.campaign.targetid)">
			<td><b>{{ $t("utm.targetid") }}</b></td>
			<td>{{ utm.campaign.targetid }}</td>
		</tr>
		</tbody>
	</table>
</template>



<script>
export default {
	name: "CardTicketUtm",
	props: {
		utm: {
			default: () => ({})
		},
		source: {
			type: String,
			default: () => ("")
		},
	},
	computed: {
		hideUtm: function () {
			let { source, utm } = this;
			if(source) {
				return  false;
			}
			let isEmpty = true;
			if(utm) {
				for(let key in this.utm) {
					if(this.isNotEmpty(this.utm[key])) {
						isEmpty = false;
						break;
					}
				}
			}
			return isEmpty;
		}
	},
	methods: {
		isNotEmpty: (value) => value && value !== 'undefined',
	},
}
</script>

<style scoped>

</style>
